module.exports = __webpack_public_path__ + "img/img-a266eb.jpg";